export { default } from './MegaSale';
export type { MegaSalePageProps } from './MegaSale';
